<template>
    <div>
        <div class="form-group">
            <label><b>Staffel Basis</b></label>
            <select class="form-control" v-model="config.base">
                <option value="umsatz">Umsatz</option>
                <option value="absatz">Absatz</option>
            </select>
        </div>
        <div class="form-group">
            <label><b>Staffel Art</b></label>
            <select class="form-control" v-model="config.type">
                <option value="performance">Performance</option>
                <option value="performance-markt">Performance ggü. Marktentwicklung</option>
                <option value="absolut">Absoluter Wert YTD</option>
                <option value="fix">Fixer Betrag</option>
                <option value="mehrumsatz" v-if="config.base === 'umsatz'">Bonus auf Mehrumsatz</option>
            </select>
        </div>
        <div class="form-group" v-if="config.type === 'performance-markt'">
            <label><b>Marktentwicklung</b></label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">Prozent</span>
                </div>
                <input type="text" class="form-control" placeholder="5" v-model="config.marktPercent">
            </div>
        </div>
        <div class="form-group" v-if="config.type === 'fix'">
            <label><b>Betrag</b></label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">Euro</span>
                </div>
                <input type="text" class="form-control" placeholder="10.000" v-model="config.fixEuro">
            </div>
        </div>
        <div class="row" v-if="config.type === 'mehrumsatz'">
            <div class="col">
                <div class="form-group">
                    <label><b>Vergütung</b></label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Prozent</span>
                        </div>
                        <input type="text" class="form-control" placeholder="5" v-model="config.muVerguetungPercent">
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label><b>Maximales Wachstum</b></label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Prozent</span>
                        </div>
                        <input type="text" class="form-control" placeholder="25" v-model="config.muMaximalPercent">
                    </div>
                </div>
            </div>
        </div>
        <div v-if="config.type !== 'fix' && config.type !== 'mehrumsatz'">
            <a href="#" class="btn btn-sm btn-outline-primary mb-3" @click.prevent="add">Staffelung hinzufügen</a>
            <div v-for="(tier, index) in config.tiers" :key="tier._uuid" class="row">
                <div class="col">
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Staffel</span>
                            </div>
                            <input type="text" class="form-control" placeholder="0" v-model="tier.start">
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="0" v-model="tier.value">
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-secondary" @click="remove(index)">
                        <i class="fas fa-trash"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="form-group" v-if="config.type !== 'fix'">
            <label><b>Maximale Vergütung</b></label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">Euro</span>
                </div>
                <input type="text" class="form-control" placeholder="0" v-model="config.maxBonus">
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        dto: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            config: this.dto
        };
    },
    methods: {
        add() {
            this.config.tiers.push({
                _uuid: this.$uuid.v4()
            });
        },
        remove(index) {
            this.config.tiers.splice(index, 1);
        }
    },
    computed: {

    },
    watch: {
        'config.base': function(newVal, oldVal) {
            if (newVal === 'absatz' && this.config.type === 'mehrumsatz') {
                this.config.type = 'performance';
            }
        }
    }
}
</script>
